import { Directive, Input } from '@angular/core';

type Placement = 'after-description' | 'fields';

@Directive({
  selector: '[crmLoggerContent]',

})
export class CrmLoggerContentDirective {
  @Input() set crmLoggerContent(value: Placement) {
    this.placement = value;
  }
  placement?: Placement;
}
